import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { RouteInfo } from '../sidebar/sidebar.component';
import { ClientsService } from './clients.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { chain } from 'lodash';
import { AvailableForm } from 'app/models/AvailableForm';
import { EmployeeServices } from './hris/employee.service';
import { SurveyManagementService } from './client-support/survey-management.service';
import { FeatureFlagService } from './feature-flag.service';
import { environment } from 'environments/environment';
import { FEATURE_FLAGS } from 'app/shared/constants/feature-flags.constants';

@Injectable({
	providedIn: 'root',
})
export class NavService {
	private readonly _routes$ = new BehaviorSubject<RouteInfo[]>([]);
	readonly routes: Observable<RouteInfo[]> = this._routes$.asObservable();
	private readonly cancelNav$ = new Subject<void>();
	ROUTES: RouteInfo[] = [];
	private availableSections = [
		{
			path: '/forms',
			title: 'Budgeting',
			type: 'sub',
			collapse: 'budgeting',
			children: [],
		},
		{
			path: '/licenses',
			title: 'Licensing',
			type: 'sub',
			collapse: 'permits-licensing',
			children: [],
		},
		{
			path: '/permits',
			title: 'Permitting',
			type: 'sub',
			collapse: 'permits',
			children: [],
		},
		{
			path: '/water-utility',
			title: 'Water Utility',
			type: 'sub',
			collapse: 'water-utility',
			children: [],
		},
		{
			path: '/forms',
			title: 'Purchasing',
			type: 'sub',
			collapse: 'purchasing',
			children: [],
		},
		{
			path: '/forms',
			title: 'Payments',
			type: 'sub',
			collapse: 'payments',
			children: [],
		},
		{
			path: '/miscellaneous-billing',
			title: 'Billing & AR',
			type: 'sub',
			collapse: 'miscellaneous-billing',
			children: [],
		},
		{
			path: '/inventory-and-work-orders',
			title: 'Inventory & Work Orders',
			type: 'sub',
			collapse: 'inventory-and-work-orders',
			children: [],
		},
		{
			path: '/project-grants',
			title: 'Projects & Grants',
			type: 'sub',
			collapse: 'project-grants',
			children: [],
		},
		{
			path: '/capital-assets',
			title: 'Capital Assets',
			type: 'sub',
			collapse: 'capital-item',
			children: [],
		},
		{
			path: '/forms',
			title: 'Cashiering',
			type: 'sub',
			collapse: 'cashiering-report',
			children: [],
		},
		{
			path: '/forms',
			title: 'HR and Payroll',
			type: 'sub',
			collapse: 'hr',
			children: [],
		},
		{
			path: '/forms',
			title: 'HR',
			type: 'sub',
			collapse: 'hris',
			children: [],
		},
		{
			path: '/forms',
			title: 'Payroll',
			type: 'sub',
			collapse: 'payroll',
			children: [],
		},
		{
			path: '/forms',
			title: 'Help Desk',
			type: 'sub',
			collapse: 'help-desk',
			children: [],
		},
		{
			path: '/generalledger',
			title: 'General Ledger',
			type: 'sub',
			collapse: 'general-ledger',
			children: [],
		},
		{
			path: '/generalledger',
			title: 'Treasury Management',
			type: 'sub',
			collapse: 'treasury-management',
			children: [],
		},
		{
			path: '/generalledger',
			title: 'Reporting',
			type: 'sub',
			collapse: 'custom-reporting',
			children: [],
		},
		{
			path: '/capital-lease',
			title: 'Lease Accounting',
			type: 'sub',
			collapse: 'capital-lease-accounting',
			children: [],
		},
		{
			path: '/utility-billing',
			title: 'Utility Billing',
			type: 'sub',
			collapse: 'utility-billing',
			children: [],
		},
		{
			path: '/forms',
			title: 'Implementation',
			type: 'sub',
			collapse: 'implementation',
			children: [],
		},
		{
			path: '/templates',
			title: 'Templates',
			type: 'sub',
			collapse: 'templates',
			children: [],
		},
		{
			path: '/workflow-management',
			title: 'Workflow Management',
			type: 'sub',
			collapse: 'workflow-management',
			children: [],
		},
		{
			path: '/user-management',
			title: 'User Management',
			type: 'sub',
			collapse: 'user-management',
			children: [],
		},
		{
			path: '/training',
			title: 'Training',
			type: 'sub',
			collapse: 'training',
			children: [],
		},
		{
			path: '/code-enforcement',
			title: 'Code Enforcement',
			type: 'sub',
			collapse: 'code-enforcement',
			children: [],
		},
		{
			path: '/announcements',
			title: 'Announcements',
			type: 'sub',
			collapse: 'announcements',
			children: [],
		},
		{
			path: '/dynamic-forms',
			title: 'Dynamic Forms',
			type: 'sub',
			collapse: 'dynamic-forms',
			children: [],
		},
		{
			path: '/integrations',
			title: 'Integrations',
			type: 'sub',
			collapse: 'integrations',
			children: [],
		},
		{
			path: '/land-management',
			title: 'Land Management',
			type: 'sub',
			collapse: 'land-management',
			children: [],
		},
		{
			path: '/recreation',
			title: 'Recreation',
			type: 'sub',
			collapse: 'recreation',
			children: [],
		},
		{
			path: '/segmentation',
			title: 'Segmentation',
			type: 'sub',
			collapse: 'segmentation',
			children: [],
		},
		{
			path: '/policies-procedures',
			title: 'Policies and Procedures',
			type: 'sub',
			collapse: 'policies-procedures',
			children: [],
		},
		{
			path: '/special-assessment',
			title: 'Special Assessments',
			type: 'sub',
			collapse: 'special-assessment',
			children: [],
		},
		{
			path: '/billing-forms',
			title: 'Billing Forms',
			type: 'sub',
			collapse: 'billing-forms',
			children: [],
		},
		{
			path: '/forms',
			title: 'Client Support',
			type: 'sub',
			collapse: 'client-support',
			children: [],
		},
	];

	constructor(
		private userServices: UserService,
		private clientServices: ClientsService,
		private employeeServices: EmployeeServices,
		private surveyManagementService: SurveyManagementService,
		private featureFlagService: FeatureFlagService
	) {
		this.updateNav();
	}

	private initNav() {
		for (const item of this.availableSections) {
			item.children = [];
		}
	}

	updateNav() {
		this.ROUTES = [];
		const user = this.userServices.currentUserValue?.user;
		const client = user?.clientId;
		const isAdmin = this.userServices.isAdmin();
		// EN-5154: SYS_ADMIN only. isAdmin also admits Aclarian Support, who must not see pricing.
		const isSysAdmin = this.userServices.isAdminOnly();
		const isUserAccessAdmin = this.userServices.isUserAccessAdmin();
		const isViewOnly = this.userServices.isReadOnlyView();
		const userAccessAdminNav: RouteInfo[] = [
			{
				path: '/admin',
				title: 'Administrator',
				type: 'sub',
				collapse: 'Administrator',
				children: [
					{
						path: 'administrative-roles-management',
						title: 'Administrative Roles Management',
						ab: 'ARM',
						enabled: true,
					},
					{
						path: 'temporary-role-assignments',
						title: 'Temporary Roles Assignment',
						ab: 'TRA',
						enabled: true,
					},
				],
			},
		];
		const adminNav: RouteInfo[] = [
			{
				path: '/admin',
				title: 'Administrator',
				type: 'sub',
				collapse: 'Administrator',
				children: [
					{ path: 'clients/list', title: 'Client List', ab: 'CL', enabled: true },
					{ path: 'clients/add', title: 'Add Client', ab: 'AD', enabled: true },
					{ path: 'users/list', title: 'User List', ab: 'UL', enabled: true },
					{ path: 'users/add', title: 'Add User', ab: 'AU', enabled: true },
					{ path: 'configuration/list', title: 'Configurations List', ab: 'CONF', enabled: true },
					{ path: 'roles', title: 'Roles', ab: 'PR', enabled: true },
					{ path: 'payment-listing', title: 'Payments Listing Reports Update', ab: 'PL', enabled: true },
					{ path: 'workflow-forms-configuration', title: 'Workflow Editable Configuration', ab: 'WF', enabled: true },
					{
						path: 'administrative-roles-management',
						title: 'Administrative Roles Management',
						ab: 'ARM',
						enabled: true,
					},
					{ path: 'aichatlogs', title: 'AI Chat Logs', ab: 'AI', enabled: true },
					{ path: 'survey-management', title: 'Survey Management', ab: 'SM', enabled: true },
					{ path: 'client-survey-report', title: 'Survey Report', ab: 'CSR', enabled: true },
					{ path: 'faq-management', title: 'FAQ Management', ab: 'CSR', enabled: true },
					{ path: 'client-survey-management', title: 'Client Survey Management', ab: 'CSR', enabled: true },
					{
						path: 'client-enhancement-request-management',
						title: 'Enhancement Request Management',
						ab: 'CERM',
						enabled: true,
					},
					{ path: 'ach-file-name-format-config', title: 'ACH File Name Config', ab: 'PL', enabled: true },
					{ path: 'client-sharing-config', title: 'Client Data Sharing Configuration', ab: 'CSC', enabled: true },
					{
						path: 'ach-batch-holiday-configurations',
						title: 'ACH Batch Holiday Configurations',
						ab: 'ABHC',
						enabled: true,
					},
					{
						path: 'client-readiness-verification',
						title: 'Client Readiness Verification',
						ab: 'CRV',
						enabled: true,
					},
					{
						path: 'ai-token-credits',
						title: 'AI Token Credits',
						ab: 'ATC',
						enabled: true,
					},
					// Listed next to AI Token Credits; sortAndEmitRoutes orders the section by title.
					...(isSysAdmin
						? [
								{
									path: 'ai-cost-margin',
									title: 'AI Cost and Margin',
									ab: 'ACM',
									enabled: true,
								},
							]
						: []),
					{
						path: 'journal-entry-publisher',
						title: 'Journal Entry Event Publisher',
						ab: 'JEEP',
						enabled: true,
					},
					{
						path: 'online-users',
						title: 'Online Users',
						ab: 'OU',
						enabled: true,
					},
					{
						path: 'ai-agent-connections',
						title: 'AI Agent Connections',
						ab: 'AAC',
						enabled: true,
					},
					{
						path: 'temporary-role-assignments',
						title: 'Temporary Roles Assignment',
						ab: 'TRA',
						enabled: true,
					},
					{
						path: 'email-domain-whitelist-management',
						title: 'Email Whitelist Management',
						ab: 'DWM',
						enabled: true,
					},
					{
						path: 'system-mass-email',
						title: 'System Mass Email',
						ab: 'SME',
						enabled: true,
					},
					{
						path: 'irs-reporting-thresholds',
						title: 'IRS Reporting Thresholds',
						ab: 'IRT',
						enabled: true,
					},
					{
						path: 'payment-file-configuration',
						title: 'Payment File Configuration',
						ab: 'PFC',
						enabled: true,
					},
					{
						path: 'vendor-payment-history-import',
						title: 'Vendor Payment History Import',
						ab: 'VPHI',
						enabled: true,
					},
					{
						path: 'transaction-detail-import',
						title: 'Segmentation & Project/Grant Transaction History Import',
						ab: 'SPGTHI',
						enabled: true,
					},
					{
						path: 'recalculate-balances',
						title: 'Recalculate Balances',
						ab: 'RB',
						enabled: true,
					},
					{
						path: 'email-domain-whitelist-management',
						title: 'Email Whitelist Management',
						ab: 'DWM',
						enabled: true,
					},
					{
						path: 'required-field-admin-configuration',
						title: 'Required Field Admin Configuration',
						ab: 'RFAC',
						enabled: true,
					},
					{
						path: 'required-field-client-configuration',
						title: 'Required Field Client Configuration',
						ab: 'RFCC',
						enabled: true,
					},
				],
				order: 0,
				isLocalSection: true,
			},
		];
		const clientAdminNav: RouteInfo[] = [
			{
				path: '/',
				title: 'Users',
				type: 'sub',
				collapse: 'ClientAdmin',
				children: [],
				enabled: true,
				order: 0,
				isLocalSection: true,
			},
		];

		const entireNav: RouteInfo[] = [
			{
				path: '/dashboard',
				title: 'Dashboard',
				type: 'link',
				order: 1,
				enabled: true,
			},
			{
				path: '/pages/form-search',
				title: 'Form Search',
				type: 'link',
				order: 2,
				enabled: true,
			},
			{
				path: '/pages/quick-approval',
				title: 'Quick Approval',
				type: 'link',
				order: 3,
				enabled: true,
			},
		];

		this.initNav();

		if (user?.claims?.[user.clientId]?.canAddUser) {
			clientAdminNav[0].children.push({ path: 'client-users/add', title: 'Add User', ab: 'CAU', enabled: true });
		}

		if (user?.claims?.[user.clientId]?.canViewUser) {
			clientAdminNav[0].children.push({ path: 'client-users/list', title: 'Users List', ab: 'CUL', enabled: true });
		}

		if (isAdmin) {
			this.ROUTES = adminNav;
		} else if (isUserAccessAdmin) {
			this.ROUTES = userAccessAdminNav;
		} else if (user?.claims?.[user.clientId]?.canViewUser || user?.claims?.[user.clientId]?.canAddUser) {
			this.ROUTES = clientAdminNav;
		} else if (isViewOnly) {
			this.ROUTES = [];
		}
		if (isAdmin) {
			this.ROUTES.push({
				path: '/pages/issues-report',
				type: 'link',
				order: 0.1,
				title: 'Issues Report',
				enabled: true,
			});
			this.ROUTES.push({
				path: '/pages/unclear-transactions-issues',
				type: 'link',
				order: 0.1,
				title: 'Unclear Transaction Report',
				enabled: true,
			});
		}

		if (this.userServices.isAclarianEmployee() || isAdmin) {
			this.ROUTES.push({
				path: '/forms/monthly-timesheet',
				title: 'Monthly Time Sheet',
				type: 'link',
				order: 1.1,
				enabled: true,
			});
		}

		if (this.userServices?.currentUserValue?.user?.clients?.length > 1) {
			this.ROUTES.push({
				path: '/multi-client-dashboard',
				title: 'Multi Client Dashboard',
				type: 'link',
				order: 0.2,
				enabled: true,
			});
		}

		if (client || this.userServices.isAclarianEmployee()) {
			for (const nav of entireNav) {
				this.ROUTES.push(nav);
			}
		}

		// Phase 7 (EN-3700) — the in-portal Agent's nav entry, gated on the client-scoped PortalAgent
		// flag so it is hidden for clients without the feature. The flag check is a one-shot async HTTP;
		// on a positive result we push the entry and re-emit so the sidebar updates without a full nav
		// rebuild. NOTE: not gated on cancelNav$ — that subject is .next()'d later in this same pass
		// (the getClientForms block below), which would cancel this still-pending request before it
		// resolves. Instead we take(1) and re-verify the client hasn't changed before pushing.
		if (client) {
			const flagClient = client;
			this.featureFlagService
				.isFeatureEnabledForClient(flagClient, FEATURE_FLAGS.PORTAL_AGENT)
				.pipe(take(1))
				.subscribe({
					next: (enabled) => {
						const stillSameClient = this.userServices.currentUserValue?.user?.clientId === flagClient;
						if (enabled && stillSameClient && !this.ROUTES.some((r) => r.path === '/claire')) {
							// EN-5079: an expandable item with New chat and Saved chats. The sidebar builds
							// each child link as path + '/' + child path, so these land on claire/new and
							// claire/saved. isLocalSection keeps the admin "enable everything" pass off it:
							// this entry is shown by the flag above and nothing else.
							this.ROUTES.push({
								path: '/claire',
								title: 'Claire',
								type: 'sub',
								collapse: 'Claire',
								order: 1.05,
								enabled: true,
								isLocalSection: true,
								children: [
									{ path: 'new', title: 'New chat', ab: 'NC', type: 'link', enabled: true },
									{ path: 'saved', title: 'Saved chats', ab: 'SC', type: 'link', enabled: true },
								],
							});
							this._routes$.next([...this.ROUTES]);
						}
					},
					// Swallow flag-check failures: a network error must not break the rest of the nav,
					// it just leaves the (optional) Claire entry hidden until the next rebuild.
					error: (error) => {
						console.error('Error checking PortalAgent feature flag for navigation:', error);
					},
				});
		}

		// push menu for all _ if env is PROD only visisble to Sample City
		const currentClientId = this.userServices?.currentUserValue?.user?.clientId;
		if (!environment.production || (currentClientId === environment.sampleCity && environment.production)) {
			this.ROUTES.push({
				path: '/pages/client-implementation',
				title: 'Client Implementation',
				type: 'link',
				order: 4,
				enabled: true,
			});
		}

		if (user) {
			if (client) {
				this.cancelNav$.next();
				this._routes$.next(this.ROUTES);
				this.clientServices
					.getClientForms(client, true)
					.pipe(
						takeUntil(this.cancelNav$),
						switchMap((data) =>
							this.employeeServices.getLogedInEmployeeId(this.userServices.currentUserValue.user.clientId).pipe(
								takeUntil(this.cancelNav$),
								tap((employeeId) => {
									let filteredData = data;
									if (!employeeId) {
										filteredData = data.filter((route) => !route.path?.includes('employee/details'));
									}
									this.setupFormTwo(filteredData.filter((t) => t.isEnabled));
								})
							)
						)
					)
					.subscribe();
			} else {
				this._routes$.next(this.ROUTES);
			}
		}
	}

	private setupFormTwo(availableItems: AvailableForm[]) {
		const isAdmin = this.userServices.isAdmin();
		const user = this.userServices.currentUserValue?.user;
		const client = user?.clientId;
		const clientForms = availableItems.filter((t) => t.isEnabled);
		const isViewOnly = this.userServices.isReadOnlyView();
		for (const clientForm of clientForms) {
			clientForm.isEnabled =
				user.claims[client]?.claims.find((z) => z.id === clientForm.id)?.visible || false || isAdmin || isViewOnly;
		}

		if (user.id === '9219a0e3-c237-49cb-99bf-a70a8bb29ddb') {
			clientForms.push({
				clientIds: [],
				id: 'monthly-timesheet',
				isEnabled: true,
				name: 'Monthly Time Sheet',
				path: '/forms/monthly-timesheet',
				section: 'HR and Payroll',
				sectionId: 'hr',
				showInDashboard: true,
				type: 'link',
			});
		}

		this.userServices.availableForms = clientForms.filter((t) => t.isEnabled);

		const groupedSections = chain(this.userServices.availableForms)
			.groupBy((t) => t.sectionId)
			.map((value, key) => {
				return { name: key, items: value };
			})
			.value();

		let clientSupportSection = null;

		for (const group of groupedSections) {
			const forms = chain(group.items)
				.orderBy((t) => t.name)
				.value();
			const section = this.availableSections.find((t) => t.collapse === group.name);

			if (section !== undefined) {
				for (const form of forms) {
					const item = {
						type: form.type,
						path: form.path,
						title: form.name,
						id: form.id,
					};
					section.children.push(item);
				}

				if (group.name === 'client-support') {
					clientSupportSection = section;
				} else {
					for (const child of section.children) {
						child.enabled = user.claims[client]?.claims.find((z) => z.id === child.id)?.visible || false;
					}

					// @ts-expect-error: `children` might be undefined, but we handle it with optional chaining
					section.enabled = section.children?.some((y) => y.enabled) || false;

					if (section.children.length > 0 && !this.ROUTES.includes(section)) {
						this.ROUTES.push(section);
					}
				}
			}
		}

		if (clientSupportSection) {
			this.addDynamicSurveyItems(clientSupportSection, user, client);
		} else {
			this.sortAndEmitRoutes();
		}
	}

	private sortAndEmitRoutes(): void {
		this.ROUTES = chain(this.ROUTES)
			.orderBy((t) => t.title)
			.sortBy((t) => (t.title === 'Client Support' ? 0 : 1))
			.value();
		this.ROUTES = chain(this.ROUTES)
			.orderBy((t) => t.order)
			.value();

		for (const item of this.ROUTES) {
			item.children = chain(item.children)
				.orderBy((t) => t.title)
				.value();
		}

		this._routes$.next(this.ROUTES);
	}

	private addDynamicSurveyItems(section: any, user: any, client: string): void {
		if (!this.userServices.isAdmin()) {
			this.finishClientSupportSection(section, user, client);
			return;
		}

		this.surveyManagementService
			.getAllFormsForNavigation()
			.pipe(takeUntil(this.cancelNav$))
			.subscribe({
				next: (surveys) => {
					const activeSurveys = surveys.filter((survey) => survey.isActive);

					activeSurveys.forEach((survey) => {
						const surveyItem = {
							type: 'form',
							path: `/client-survey-form/survey/${survey.id}`,
							title: survey.title,
							id: `survey-${survey.id}`,
						};
						section.children.push(surveyItem);
					});

					this.finishClientSupportSection(section, user, client);
				},
				error: () => {
					this.finishClientSupportSection(section, user, client);
				},
			});
	}

	private finishClientSupportSection(section: any, user: any, client: string): void {
		section.children.sort((a, b) => a.title.localeCompare(b.title));

		for (const child of section.children) {
			child.enabled = user.claims[client]?.claims.find((z) => z.id === child.id)?.visible || false;
		}
		section.enabled = section.children?.some((y) => y.enabled) || false;

		if (section.children.length > 0 && !this.ROUTES.includes(section)) {
			this.ROUTES.push(section);
		}

		this.sortAndEmitRoutes();
	}
}
